/**
 * Maps document types to their search index names.
 *
 * Note: There is a similar but inverted mapping in apps/nextjs/i18n/algolia/indices.ts
 * (SEARCH_INDEX_TO_DOCTYPE). Consider consolidating these mappings in the future
 * to avoid duplication and potential inconsistencies.
 */
export const DOCTYPES_TO_SEARCH_INDEX = {
   'topic': 'topic',
   'product': 'product',
   'guide': 'guide',
   'post': 'post',
   'wiki': 'wiki',
   'item': 'item',
   'pages': 'searchpage',
   'news': 'wp_searchable_posts',
   'document': 'document',
} as const;

export type Doctype = keyof typeof DOCTYPES_TO_SEARCH_INDEX;
